import React from 'react';
import { Search, ChevronDown, ChevronRight } from 'lucide-react';

const TrackingRow = ({ category, amount, progress, isExpanded, onToggle }) => (
  <tr className="hover:bg-slate-50 transition-colors">
    <td className="px-6 py-4 text-sm font-bold text-[#041627]">{category}</td>
    <td className="px-6 py-4 text-sm text-slate-600 font-medium">{amount}</td>
    <td className="px-6 py-4">
      <div className="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden">
        <div className="h-full bg-[#041627]" style={{ width: `${progress}%` }}></div>
      </div>
    </td>
    <td className="px-6 py-4">
      <button
        onClick={onToggle}
        className="text-slate-400 hover:text-[#041627] transition-colors flex items-center gap-1"
      >
        {isExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        <Search size={14} />
      </button>
    </td>
  </tr>
);

export default TrackingRow;